import React, { useEffect, useState } from "react";
import { emptyGameboard, Gameboard as GameboardType } from "../../system/types/gameboard/gameboard.types"
import { GameBoardApi } from "../../system/api/GameBoardApi";
import { Summary } from "./Summary";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { ApiResponse } from "../../system/types/api/apiresponse.types";
import { Field } from "./Field";

import "./Gameboard.scss";
import { Solution } from "./Solution";
import Icon from "@mdi/react";
import { mdiGrid, mdiGridOff, mdiMoveResize, mdiRefresh, mdiRestore } from "@mdi/js";

const Gameboard = () => {
    const [boardData, setBoardData] = useState<GameboardType>(emptyGameboard);
    const [systemInit, setSystemInit] = useState<boolean>(false);

    const [summaryCol, setSummaryCol] = useState<number[]>([]);
    const [summaryRow, setSummaryRow] = useState<number[]>([]);
    const [matrix, setMatrix] = useState<number[][]>([]);
    const [points, setPoints] = useState<number[][]>([]);

    const [summaryColResults, setSummaryColResult] = useState<number[]>([]);
    const [summaryRowResults, setSummaryRowResult] = useState<number[]>([]);

    const [matrixSize, setMatrixSize] = useState<number>(5);

    const [showSolution, setShowSolution] = useState<boolean>(false);
    const [resetFields, setResetFields] = useState<boolean>(false);


    useSelector((state: RootState) => {
        if (state.system.initDone !== systemInit) {
            setSystemInit(state.system.initDone);
        }
    });

    const loadNewBoard = async () => {
        const api = new GameBoardApi();

        let response: ApiResponse<GameboardType> = {
            status: 500,
            data: emptyGameboard,
            error: ['exection failure']
        };

        try {
            const ApiResponse = await api.getNewBoard(matrixSize) as ApiResponse<GameboardType>;
            if (typeof ApiResponse !== 'undefined') {
                response = ApiResponse;
            }
        } catch (e) {
            console.error(e);
            return;
        }

        if (response.status >= 300) {
            console.error(response.error);
            return;
        }

        setBoardData(response.data);
    };

    const initMatrixData = () => {

        if (typeof boardData === 'undefined') {
            return;
        }

        console.log(boardData);

        setSummaryCol(boardData.summary.col);
        setSummaryRow(boardData.summary.row);
        setMatrix(boardData.matrix);
        setPoints(boardData.points);
        setSummaryRowResult([]);
        setSummaryColResult([]);
        setShowSolution(false);
        setResetFields(true);
    };

    const checkFieldActive = (isActive: boolean, row: number, col: number, value: number) => {

        const rowsSum = [...summaryRowResults];
        const colsSum = [...summaryColResults];

        let sumValRow = getCheckResultRow(row);
        let sumValCol = getCheckResultCol(col);


        let calcVal = value;
        if (!isActive) {
            calcVal = calcVal * -1;
        }

        sumValRow += calcVal;
        if (sumValRow < 0) {
            sumValRow = 0;
        }

        sumValCol += calcVal;
        if (sumValCol < 0) {
            sumValCol = 0;
        }

        rowsSum[row] = sumValRow;
        colsSum[col] = sumValCol;

        setSummaryRowResult(rowsSum);
        setSummaryColResult(colsSum);

    }

    const changeMatrixSize = (event: any) => {
        const newValue = event.target.value;
        setMatrixSize(newValue);
    }

    const checkSummaryCol = (isValid: boolean, index: number) => {

    }

    const checkSummaryRow = (isValid: boolean, index: number) => {

    }

    const getCheckResultCol = (index: number) => {
        if (typeof summaryColResults[index] === 'undefined') {
            return 0;
        }

        return summaryColResults[index];
    };

    const getCheckResultRow = (index: number) => {
        if (typeof summaryRowResults[index] === 'undefined') {
            return 0;
        }

        return summaryRowResults[index];
    };

    const clearFields = () => {
        setResetFields(true);
        setSummaryRowResult([]);
        setSummaryColResult([]);
    };

    const toggleSolution = () => {
        setShowSolution(!showSolution);
    }

    const getGameBoardClass = () => {
        return 'gameBoard size-' + matrixSize;
    }

    useEffect(() => {
        if (!systemInit) {
            return;
        }

        loadNewBoard();
    }, [systemInit]);

    useEffect(() => {
        initMatrixData();
    }, [boardData]);

    useEffect(() => {
        //(summaryColResults, summaryRowResults);
    }, [summaryColResults, summaryRowResults]);

    useEffect(() => {
        if (!resetFields) {
            return;
        }

        setResetFields(false);
    }, [resetFields]);

    useEffect(() => {
        loadNewBoard();
    },[matrixSize]);

    return (<div className={getGameBoardClass()}>
        <div className="settings row">
            <div className="col-auto">
                <div className="input-group formElement">
                    <label className="input-group-text" id="selectLanguageLabel" title="Spielfeldgröße"><Icon path={mdiMoveResize} size={1} /></label>
                    <select
                        id="selectLanguage"
                        name="selectLanguage"
                        className="form-control"
                        aria-label="Spielfeldgröße"
                        aria-describedby="selectLanguageLabel"
                        onChange={changeMatrixSize}
                        value={matrixSize}
                    >
                        <option key={5} value={5}>{5}</option>
                        <option key={6} value={6}>{6}</option>
                        <option key={7} value={7}>{7}</option>
                        <option key={8} value={8}>{8}</option>
                        <option key={9} value={9}>{9}</option>
                        <option key={11} value={11}>{11}</option>
                        <option key={13} value={13}>{13}</option>
                        <option key={17} value={17}>{17}</option>
                    </select>
                </div>
            </div>
            <div className="col-auto"><button className="btn btn-primary" onClick={loadNewBoard} title="neues Spiel"><Icon path={mdiRefresh} size={1} /></button></div>
            <div className="col-auto"><button className="btn btn-primary" onClick={toggleSolution} title="Lösung">{
                showSolution ? <Icon path={mdiGridOff} size={1} />: <Icon path={mdiGrid} size={1} />
            }</button></div>
            <div className="col-auto"><button className="btn btn-primary" onClick={clearFields} title="Spiel neu starten"><Icon path={mdiRestore} size={1} /></button></div>
        </div>
        <div className="summaryCols">
            {
                summaryCol.map((sum, index) => (
                    <Summary key={index} value={sum} index={index} checkValue={getCheckResultCol(index)} isValid={checkSummaryRow}></Summary>
                ))
            }
        </div>
        <div className="summaryRows">
            {
                summaryRow.map((sum, index) => (
                    <Summary key={index} value={sum} index={index} checkValue={getCheckResultRow(index)} isValid={checkSummaryCol}></Summary>
                ))
            }
        </div>
        <div className="matrix">
            {
                matrix.map((rowData, row) => (
                    <div key={row} className="rowData">
                        {
                            rowData.map((colData, col) => (
                                <Field
                                    key={row + '_' + col}
                                    value={colData}
                                    row={row}
                                    col={col}
                                    setReset={resetFields}
                                    setActive={checkFieldActive}
                                ></Field>
                            ))
                        }
                    </div>
                ))
            }
        </div>
        {showSolution ? <Solution points={points} size={matrixSize}></Solution> : null}
        
    </div>);
};

export { Gameboard };
